import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Stack from '@mui/material/Stack'
import { FilterMode } from './FilterMode'
import { StyledCheckbox } from '@/components/molecules/input/StyledCheckbox'
import { RcTrans } from '@/components/atoms/RcTrans'
import { RcIcon } from '@/components/atoms/RcIcon'

const modes = [FilterMode.RequireNetwork, FilterMode.NotRequireNetwork]
export const RequiredNetworksMenu = ({
  filterMode,
  onSelected
}: {
  filterMode: FilterMode | undefined
  onSelected: (sort?: FilterMode) => any
}) => {
  return (
    <Box p={2}>
      <FormControl sx={{ px: 2 }}>
        <FormGroup>
          <FormControlLabel
            label={
              <RcTrans i18nKey='competition:teams.filters.not-missing-network' />
            }
            control={
              <StyledCheckbox
                checked={filterMode === FilterMode.NotRequireNetwork}
                onChange={() =>
                  onSelected(
                    filterMode === FilterMode.NotRequireNetwork
                      ? undefined
                      : FilterMode.NotRequireNetwork
                  )
                }
              />
            }
          />
          <FormControlLabel
            label={
              <RcTrans i18nKey='competition:teams.filters.missing-network' />
            }
            control={
              <StyledCheckbox
                checked={filterMode === FilterMode.RequireNetwork}
                onChange={() =>
                  onSelected(
                    filterMode === FilterMode.RequireNetwork
                      ? undefined
                      : FilterMode.RequireNetwork
                  )
                }
              />
            }
          />
        </FormGroup>
      </FormControl>

      <Box flexGrow={1} />

      <Stack
        direction='row'
        justifyContent={'space-between'}
        spacing={2}
        pt={3}
      >
        <Button
          disabled={!modes.includes(filterMode!)}
          onClick={() =>
            onSelected(modes.includes(filterMode!) ? undefined : filterMode)
          }
          variant='outlined'
          size='small'
          color='info'
          fullWidth
        >
          <RcIcon icon={['fal', 'filter-slash']} mr={2} />
          <RcTrans i18nKey='competition:teams.actions.clear-filter' />
        </Button>
      </Stack>
    </Box>
  )
}
